<template>
  <div>
    <BRow>
      <BCol lg="4">
        <Card
          :title="'Saldo Komerce'"
          :loading="loading.balance"
          :item="data.balance"
          :on-click="getMonit"
          :image-path="'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/rotate-left-1.svg'"
          :tooltip="'Saldo Komerce di Monit'"
          :source="'balances'"
        >
          <template #extra-content>
            <div class="grid grid-cols-2 gap-4 mt-2">
              <BButton
                variant="outline-primary"
                tag="router-link"
                :to="{ name: 'topup-history' }"
              >
                Riwayat Topup
              </BButton>
              <BButton
                variant="primary"
                @click="$bvModal.show('modal-topup-balance-monit')"
              >
                Topup Saldo
              </BButton>
            </div>
          </template>
        </Card>

      </BCol>
      <BCol lg="4">
        <BCard body-class="shadow-sm">
          <div class="flex items-center mb-[10px]">
            <span class="text-black font-semibold">Tambah Kartu</span>
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="Komerce"
              class="ml-[5px] cursor-pointer"
              width="20"
            >
          </div>
          <BSpinner
            v-if="loading.available_card"
            variant="primary"
            small
          />
          <div
            v-for="(card, index) in card_types"
            v-else
            :key="index"
            class="d-flex align-items-center justify-content-between mb-[5px]"
          >
            <span class="text-black">{{ card.label }}</span>
            <BFormCheckbox
              switch
              :checked="card.active"
              @change="toggleActivateCard(card.value)"
            />
          </div>
        </BCard>
      </BCol>
    </BRow>
    <div class="mb-1 flex flex-row justify-between">
      <div class="text-black font-semibold text-xl">
        Performa Pertumbuhan User (Partner)
      </div>
      <div class="w-[120px]">
        <FlatPickr
          v-model="period"
          :config="configDate"
          class="custom-select"
        />
      </div>
    </div>
    <BRow>
      <BCol
        lg="4"
        md="4"
      >
        <Card
          :title="'Registrasi'"
          :item="data.register"
          :loading="loading.register"
          :image-path="'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/user-add.svg'"
          :tooltip="'Jumlah partner yang Register selama satu bulan'"
          :source="'register'"
        />
      </BCol>
      <BCol
        lg="4"
        md="4"
      >
        <Card
          :title="'Rasio Decline'"
          :item="data.ratio_decline"
          :loading="loading.ratio_decline"
          :image-path="'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/card-remove-1.svg'"
          :tooltip="''"
          :source="'decline'"
        />
      </BCol>
      <BCol
        lg="4"
        md="4"
      >
        <Card
          :title="'Total Kartu'"
          :item="data.card"
          :loading="loading.card"
          :image-path="'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/card-add.svg'"
          :tooltip="'Total jumlah kartu yang dibuat oleh partner'"
          :source="'card'"
        />
      </BCol>
      <BCol
        lg="6"
        md="6"
      >
        <Card
          :title="'Pengeluaran'"
          :item="data.expense"
          :loading="loading.expense"
          :image-path="'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/money-send.svg'"
          :tooltip="'Jumlah pengeluaran seluruh partner selama satu bulan'"
          :source="'expense'"
        />
      </BCol>
      <BCol
        lg="6"
        md="6"
      >
        <BOverlay
          :show="loading.categorySpending"
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
        >
          <BCard
            body-class="shadow-sm"
            class="h-[200px]"
            header-class="pb-0"
          >
            <template #header>
              <span class="text-lg font-semibold text-black">
                Kategori Pengeluaran
              </span>
            </template>
            <ApexChart
              ref="chart"
              type="donut"
              :options="spendingCategoryOptions"
              :series="categorySpending"
            />
          </BCard>
        </BOverlay>
      </BCol>
    </BRow>
    <BRow>
      <BCol lg="8">
        <Chart
          :series="data.transaction"
          :loading="loading.transaction"
          :options="optionsCardFlow"
        />
      </BCol>
      <BCol lg="4">
        <Table
          :loading="loading.items"
          :items="data.items"
        />
      </BCol>
    </BRow>

    <ModalTopupBalanceMonit
      ref="modal-topup-balance-monit"
      @topup="handleTopupData"
    />

    <ModalTOTP
      id="modal-totp-komcards"
      ref="modalTotp"
      @submit="topupBalanceMonit"
      @hidden="resetTopupData"
    />
  </div>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import { LABELMONTH, YEAR_MONTH } from '@/libs/filterDate'
import { alertError, alertSuccess } from '@toast'
import { today } from '@/store/helpers'
import FlatPickr from 'vue-flatpickr-component'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import MonthSelect from 'flatpickr/dist/plugins/monthSelect'
import ModalTOTP from '@/views/components/modal/ModalTOTP.vue'
import { handleDefaultResponse } from '@/views/components/modal/modalTOTPUtils'
import ApexChart from 'vue-apexcharts'
import isEmpty from 'lodash/isEmpty'
import Card from './Card.vue'
import Chart from './Chart.vue'
import Table from './Table.vue'
import ModalTopupBalanceMonit from './ModalTopupBalanceMonit.vue'

import { optionsCardFlow } from './config'
import '@/@core/scss/vue/libs/vue-flatpicker.scss'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import { spendingCategoryOptions } from '../data-partner/Detail/General/config'

export default {
  components: {
    Card, Chart, Table, FlatPickr, ModalTopupBalanceMonit, ModalTOTP, ApexChart,
  },
  data() {
    return {
      totpAttempts: 0,
      isEmpty,
      categorySpending: [],
      spendingCategoryOptions,
      period: today,
      monthlabel: LABELMONTH,
      IDR,
      alertError,
      alertSuccess,
      optionsCardFlow,
      data: {
        balance: {},
        register: {},
        card: {},
        expense: {},
        transaction: [],
        items: [],
        ratio_decline: {},
      },
      loading: {
        balance: false,
        register: false,
        card: false,
        expense: false,
        transaction: false,
        items: false,
        available_card: false,
        categorySpending: false,
        ratio_decline: false,
      },
      configDate: {
        mode: 'single',
        locale: Indonesian,
        altInput: true,
        altFormat: 'j/n/Y',
        dateFormat: 'Y-m-d',
        maxDate: today,
        disableMobile: true,
        plugins: [
          new MonthSelect({
            shorthand: true,
            dateFormat: 'Y-m-d',
            altFormat: 'M Y',
          }),
        ],
      },
      card_types: [
        { label: 'Platinum', active: true, value: 'platinum' },
        { label: 'Gold', active: false, value: 'gold' },
      ],

      topupData: null,
    }
  },
  watch: {
    period: {
      handler() {
        this.getGrowthPartner()
        this.getGrowthCard()
        this.getGrowthExpanse()
        this.getPartnerExpense()
        this.getFlowTransaction()
        this.getCategorySpending()
        this.getRatioDecline()
      },
    },
  },
  mounted() {
    this.getMonit()
    this.getGrowthPartner()
    this.getGrowthCard()
    this.getGrowthExpanse()
    this.getPartnerExpense()
    this.getFlowTransaction()
    this.getAvailableLevel()
    this.getCategorySpending()
    this.getRatioDecline()
  },
  methods: {
    async getAvailableLevel() {
      const url = '/komcards/api/v1/setting/available-level'
      this.loading.available_card = true
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data

          this.card_types = this.card_types.map(card => ({
            ...card,
            active: data[card.value],
          }))
          this.loading.available_card = false
        })
        .catch(() => {
          this.loading.available_card = false
          this.alertError('Gagal load data kartu tersedia')
        })
    },
    async toggleActivateCard(selected) {
      this.card_types = this.card_types.map(card => {
        if (card.value === 'platinum' && card.active && selected === 'platinum') {
          return { ...card, active: false }
        }

        if (card.value === 'gold' && card.active && selected === 'gold') {
          return { ...card, active: false }
        }

        return {
          ...card,
          active: card.value === selected,
        }
      })

      // Pastikan selalu satu aktif
      if (!this.card_types.some(c => c.active)) {
        this.card_types = this.card_types.map(c => ({
          ...c,
          active: c.value !== selected, // aktifkan lawannya
        }))
      }

      const activeCard = this.card_types.find(c => c.active)
      const url = '/komcards/api/v1/setting/available-level'

      const payload = {
        level: activeCard.value,
        is_active: true,
      }

      await newAxiosIns.put(url, payload)
        .then(() => {
          this.alertSuccess(`Kartu ${activeCard.label} berhasil diaktifkan`)
        })
        .catch(() => {
          this.alertError(`Kartu ${activeCard.label} gagal diaktifkan`)
        })
    },
    async getMonit() {
      this.loading.balance = true
      const url = '/komcards/api/v1/admin/monit/update-balance'
      await newAxiosIns.post(url)
        .then(res => {
          const { data } = res.data
          this.data.balance = data
          this.loading.balance = false
        })
        .catch(() => {
          this.loading.balance = false
          this.alertError('Gagal load data monit')
        })
    },
    async getGrowthPartner() {
      this.loading.register = true
      const params = YEAR_MONTH(this.period)
      const url = `/auth/api/v1/admin/dashboard/user-register-growth?period=${params}`
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.data.register = data
          this.loading.register = false
        })
        .catch(() => {
          this.loading.register = false
          this.alertError('Gagal load Register')
        })
    },
    async getGrowthCard() {
      this.loading.card = true
      const params = YEAR_MONTH(this.period)
      const url = `/komcards/api/v1/admin/dashboard/total-card-growth?period=${params}`
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.data.card = data
          this.loading.card = false
        })
        .catch(() => {
          this.loading.card = false
          this.alertError('Gagal load data Total kartu')
        })
    },
    async getGrowthExpanse() {
      this.loading.expense = true
      const params = YEAR_MONTH(this.period)
      const url = `/komcards/api/v1/admin/dashboard/total-card-expense?period=${params}`
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.data.expense = data
          this.loading.expense = false
        })
        .catch(() => {
          this.loading.expense = false
          this.alertError('Gagal load data Total kartu')
        })
    },
    async getFlowTransaction() {
      this.loading.transaction = true
      const params = YEAR_MONTH(this.period)
      const url = `/komcards/api/v1/dashboard/card-flow-transaction?period=${params}`
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.data.transaction = [
            {
              name: 'Transaksi Masuk',
              data: data.map(item => item.credit_amount),
            },
            {
              name: 'Transaksi Keluar',
              data: data.map(item => -item.debit_amount),
            },
          ]
          this.loading.transaction = false
          this.optionsCardFlow = {
            ...this.optionsCardFlow,
            xaxis: {
              ...this.optionsCardFlow.xaxis,
              categories: data.map(item => item.date),
            },
          }
        })
        .catch(() => {
          this.loading.transaction = false
          this.alertError('Gagal load data arus keuangan kartu')
        })
    },
    async getPartnerExpense() {
      this.loading.items = true
      const params = YEAR_MONTH(this.period)
      const url = `/komcards/api/v1/admin/dashboard/top-partner-expense?period=${params}`
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.data.items = data
          this.loading.items = false
        })
        .catch(() => {
          this.loading.items = false
          this.alertError('Gagal load data Pengeluaran Kartu')
        })
    },
    async getRatioDecline() {
      this.loading.ratio_decline = true
      const params = YEAR_MONTH(this.period)
      const url = `/komcards/api/v1/admin/dashboard/decline-ratio?period=${params}`
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.data.ratio_decline = data
          this.loading.ratio_decline = false
        })
        .catch(() => {
          this.loading.ratio_decline = false
          this.alertError('Gagal load data Rasio Decline')
        })
    },
    handleTopupData(payload) {
      this.topupData = payload
      this.$bvModal.hide('modal-topup-balance-monit')
      this.openTotpModal()
    },
    openTotpModal() {
      this.totpAttempts = 0
      this.$refs.modalTotp.show()
    },
    resetTopupData() {
      this.totpAttempts = 0
      this.topupData = null
      if (this.$refs['modal-topup-balance-monit']) {
        this.$refs['modal-topup-balance-monit'].resetData()
      }
    },
    async topupBalanceMonit(otpCode, helpers) {
      this.totpAttempts += 1
      if (helpers) helpers.setLoading(true)
      const { nominal, destination_account_id } = this.topupData

      try {
        await newAxiosIns.post('/komcards/api/v1/admin/monit/topup', {
          code: String(otpCode),
          nominal,
          destination_account_id,
        })
        this.$toast_success({ title: 'Berhasil', message: `Topup saldo ${IDR(nominal)} berhasil` })
        if (helpers) helpers.hide()
        this.getMonit()
        this.$refs['modal-topup-balance-monit'].getDataXendit()
        this.resetTopupData()
      } catch (error) {
        if (helpers) helpers.setLoading(false)
        const { message, code } = error.response?.data?.meta || {}

        const errorKey = {
          'have a pending disbursement': 'Terdapat transaksi yang belum selesai. Harap tunggu sampai transaksi selesai.',
          'destination account monit not found': 'Rekening tujuan tidak ditemukan',
          'amount is higher than the limit': 'Nominal melebihi limit. Harap cek syarat dan ketentuan transaksi.',
        }

        if (errorKey[message]) {
          if (helpers) helpers.hide()
          this.resetTopupData()
          this.$toast_error({ title: 'Gagal', message: errorKey[message] })
          return
        }

        const messageError = message || `Topup saldo ${IDR(nominal)} gagal`

        handleDefaultResponse({
          status: code || error.response?.status,
          metaMessage: messageError,
          helpers,
          totpAttempts: this.totpAttempts,
          toast: this.$toast,
        })
      }
    },
    async getCategorySpending() {
      this.loading.categorySpending = true
      try {
        const params = YEAR_MONTH(this.period)
        const url = `/komcards/api/v1/admin/dashboard/category-spending?period=${params}`
        const { data: { data } } = await newAxiosIns.get(url)

        if (isEmpty(data)) {
          this.spendingCategoryOptions = {
            ...this.spendingCategoryOptions,
            labels: ['Belum ada data'],
            colors: ['#D2B48C'],
            tooltip: {
              enabled: false,
            },
          }
          this.categorySpending = [100]
        } else {
          this.categorySpending = data.map(item => Math.round(item.percentage))
          this.spendingCategoryOptions = {
            ...this.spendingCategoryOptions,
            chart: {
              height: 'auto',
              width: 320,
            },
            labels: data.map(item => `<span class='capitalize'>${item.category}</span>`),
            colors: ['#FFD93D', '#FA812F', '#73C8D2', '#6F00FF', '#73C8D2'],
            xaxis: {
              ...this.spendingCategoryOptions.xaxis,
              categories: data.map(item => Math.round(item.spending)),
            },
            tooltip: {
              enabled: true,
              custom: opts => {
                const value = opts.w.config.series[opts.seriesIndex]
                const name = opts.w.config.labels[opts.seriesIndex]
                const amount = opts.w.config.xaxis.categories[opts.seriesIndex]

                const htmlEmptyData = '<div class="md:w-[200px] md:p-2 bg-white text-black">Belum ada data</div>'
                const htmlData = `<div class="md:w-[200px] md:p-2 bg-white text-black">
          <div class="flex items-center justify-between">
            <div class="text-[#828282] font-normal">${name}</div>
            <div class="border-left p-[2px] text-primary">${value}%</div>
          </div>
          <div class="font-bold">${IDR(amount)}</div>
        </div>
        `
                return name !== 'Tidak Ada Spending' ? htmlData : htmlEmptyData
              },
            },
          }
        }

        this.loading.categorySpending = false
      } catch {
        // this.$toast_error({ message: 'Gagal load data category spending' })
        this.loading.categorySpending = false
      }
    },
  },
}
</script>
<style>
.flatpickr-monthSelect-month.selected{
  background-color: #F95031 !important;
}
</style>
